function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#94C11F",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M93.742 29.56L101.742 29.56 101.742 36.952",
  transform: "translate(-281 -570) translate(283.14 572.704) rotate(44 97.742 33.256)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 73.412c16.158 13.807 32.727 12.89 43.843 4.952C64.047 67.508 79.933 49.72 96.499 25",
  transform: "translate(-281 -570) translate(283.14 572.704) scale(1 -1) rotate(56 153.355 0)"
}))));

var SvgArrowOverviewMd2 = function SvgArrowOverviewMd2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 114,
    viewBox: "0 0 108 114",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowOverviewMd2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowOverviewMd2.80fa63db.svg";
export { ForwardRef as ReactComponent };